import React, { useEffect } from "react";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import PaginatedView from "../../../components/UI/PaginatedView/PaginatedView";
import DetalhamentoFase from "./DetalhamentoFase";
import funcionalidades from "../../../context/AuthContext.funcionalidades";

const columns = [
  {
    name: "Nome da Fase",
    selector: "nome",
    sortable: true,
  },
  {
    name: "Descrição",
    selector: "descricao",
    sortable: true,
  },
];

const ConsultaFase = ({ history, match }) => {
  const { request } = useApiClient();

  useEffect(() => {
    request(apiRoutes.fiscalizacao.parametrizacao.consultaLivroFiscal);
    request(apiRoutes.fiscalizacao.parametrizacao.consultaRoteiro);
  }, [request]);

  return (
    <PaginatedView
      title="Fases da Ação Fiscal"
      keyField="codigo"
      descriptionField="nome"
      defaultSearch
      defaultSearchPlaceholder="Descrição"
      queryService={apiRoutes.fiscalizacao.parametrizacao.consultaFase}
      deleteService={apiRoutes.fiscalizacao.parametrizacao.excluiFase}
      editRoute={`${match.url}/form`}
      columns={columns}
      expandComponent={DetalhamentoFase}
      permissionDelete={funcionalidades.fase.deletar}
      permissionInsert={funcionalidades.fase.inserir}
      history={history}
    />
  );
};

export default ConsultaFase;
